import React from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter, Route, Routes} from 'react-router-dom'

import Home from './pages/home/Home.jsx'
import ItemBag from './pages/itemBag/ItemBag.jsx'
import ShoppingCart from './pages/shoppingCart/ShoppingCart.jsx'
import Consultation from './pages/consultation/Consultation.jsx'

import './index.scss'
import {isDebug} from "react-lf-tools";

const checkUpdates = () => {
    try {
        if (!isDebug('5173')) if ('serviceWorker' in navigator) {
            const path = (!!import.meta.env.VITE_BASE) ? `/${import.meta.env.VITE_BASE}/sw.js` : `/sw.js`
            navigator.serviceWorker.register(path)
                .then((registration) => {
                    console.log('Service Worker registrado com sucesso!')

                    registration.addEventListener('updatefound', () => {
                        const newWorker = registration.installing
                        if (newWorker) {
                            newWorker.addEventListener('statechange', () => {
                                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                    if (confirm('Uma nova versão está disponível. Atualizar agora?')) {
                                        window.location.reload()
                                    }
                                }
                            })
                        }
                    })
                })
                .catch((error) => {
                    console.error('Erro ao registrar o Service Worker main.js:', error)
                })
        }
    } catch (e) {
        console.error(e.message)
    }
}

checkUpdates()

ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter basename={`/${import.meta.env.VITE_BASE}`}>
        <Routes>
            <Route path='/' element={<Home/>}/>
            <Route path='/produto' element={<ItemBag/>}/>
            <Route path='/carrinho' element={<ShoppingCart/>}/>
            <Route path='/consulta' element={<Consultation/>}/>
        </Routes>
    </BrowserRouter>
)
